/* /assets/os-gorgias-chat.js
 * James round 6: hide-on-scroll for the Gorgias chat launcher on mobile,
 * so it isn't sitting over a product card's quick-add button while the
 * shopper is actively scrolling the grid. Toggles a class
 * (.os-gorgias-hidden) on Gorgias' own #chat-button iframe -- see
 * os-gorgias-chat.css for the actual opacity/transform. No display:none
 * (no layout shift), and this never touches Gorgias' own open/close
 * state: if the chat panel (#chat-input) is currently open, this script
 * leaves the launcher alone entirely.
 */
(function () {
  'use strict';

  var HIDE_CLASS = 'os-gorgias-hidden';
  var REVEAL_DELAY = 600;
  var lastScrollY = window.scrollY;
  var ticking = false;
  var stopTimer = null;

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function isChatOpen(chatInput) {
    return !!chatInput && getComputedStyle(chatInput).display !== 'none';
  }

  function update() {
    ticking = false;

    var chatButton = document.getElementById('chat-button');
    if (!chatButton) return;

    var chatInput = document.getElementById('chat-input');
    if (!isMobile() || isChatOpen(chatInput)) {
      chatButton.classList.remove(HIDE_CLASS);
      lastScrollY = window.scrollY;
      return;
    }

    var currentY = window.scrollY;
    var delta = currentY - lastScrollY;

    if (delta > 4 && currentY > 80) {
      chatButton.classList.add(HIDE_CLASS);
    } else if (delta < -4 || currentY <= 80) {
      chatButton.classList.remove(HIDE_CLASS);
    }

    lastScrollY = currentY;

    clearTimeout(stopTimer);
    stopTimer = setTimeout(function () {
      chatButton.classList.remove(HIDE_CLASS);
    }, REVEAL_DELAY);
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  function init() {
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
